export const API_ENDPOINTS = {
  LEAVE_TYPE_CATEGORY: {
    ADD_LEAVE_TYPE_CATEGORY: (org) => `/leave/category?org=${org}`,
    FETCH_LEAVE_TYPE_CATEGORY: "/leave/category",
    FETCH_LEAVE_TYPE_NAME: "/leave/category/type",
    UPDATE_LEAVE_TYPE_CATEGORY: (id) => `/leave/category/${id}`,
    DELETE_LEAVE_TYPE_CATEGORY: (id) => `/leave/category/${id}`,
    ADD_LEAVE_SCHEME: (org) => `/leave/scheme?org=${org}`,
    FETCH_LEAVE_SCHEME: "/leave/scheme",
    DELETE_LEAVE_SCHEME: (id) => `/leave/scheme/${id}`,
  },
  EMPLOYEE_LEAVE_BALANCE: {
    FETCH_LEAVE_BALANCE: (empId, year) => `/employee/leave/${empId}/${year}`,
    FETCH_LEAVE_BALANCE_REPORTING: (empId, year) => `/employee/leave/balance-under-reporting-manager?empId=${empId}&year=${year}`,
    FETCH_LEAVE_BALANCE_DETAILS: (empId) => `/employee/leave/${empId}`,
    ADD_LEAVE_TRANSACTION: (empId) => `/employee/leave/${empId}?org=ORG00001`,
    FETCH_LEAVE_BALANCE_BY_TYPE: (empId, year, leaveType) =>
      `employee/leave?empId=${empId}&year=${year}&leaveType=${leaveType}`,
    DELETE_AVAILED_LEAVE: "/employee/leave/delete-availed",
    UPDATE_LEAVE_BALANCE: "/leave/balance/update",
    EXPORT_LEAVE: "/employee/leave/exportForF&F",
    CUS_REPORT: "/leave/customised-report/excel",
  },
  LEAVE_GRANTER: {
    ADD_LEAVE_GRANTER: `/leave/granter`,
    FETCH_LEAVE_GRANTER: "/leave/granter/fetchTable/Leave Granter",
    UPDATE_LEAVE_GRANTER: "/leave/granter/update",
    DELETE_LEAVE_GRANTER: (id) => `/leave/granter/${id}`,
    FETCH_LEAVE_SCHEME_DETAILS: (scheme) => `/leave/granter/${scheme}`,
    FETCH_LEAVE_SCHEME_DETAILS_BY_EMP_ID: (empId) =>
      `/leave/granter/emp/${empId}`,
  },
  LEAVE_BALANCE_IMPORT: {
    LEAVE_BALANCE_UPLOAD: "/leave/balance/import",
    LEAVE_BALANCE_EXPORT: "/leave/balance/export",
    LEAVE_BALANCE_DOWNLOAD: "/leave/balance/sample-download",
    GET_LEAVE_BALANCE: "/leave/granter/fetchTable/Leave Import",
  },
  LEAVE_REPORT: {
    FETCH_LEAVE_REPORT: (month, empId, leaveType, year, active) => {
      const params = new URLSearchParams();

      if (month != null) params.append("month", month);
      if (empId != null) params.append("empId", empId);
      if (leaveType != null) params.append("leaveType", leaveType);
      if (year != null) params.append("year", year);
      if (active != null) params.append("status", active);

      return `/leave/report?${params.toString()}`;
    },
  },

  LOCK_ATTENDANCE: {
    ADD_LOCK_ATTENDANCE: (empLockDate, repLockDate, org) =>
      `/leave/lock-attendance?attendanceEmpLockDate=${empLockDate}&attendanceRepoLockDate=${repLockDate}&org=${org}`,
    FETCH_LOCK_ATTENDANCE: "/leave/lock-attendance",
    UPDATE_LOCK_ATTENDANCE: (id, empLockDate, repLockDate, org) =>
      `leave/lock-attendance/lock-date-update?id=${id}&attendanceEmpLockDate=${empLockDate}&attendanceRepoLockDate=${repLockDate}&org=${org}`,
  },

  AVAILED_LEAVE_REPORT: {
    AVAILED_LEAVE_SAMPLE_DOWNLOAD: "/employee/leave/sample-availed",
    AVAILED_LEAVE_UPLOAD: "/employee/leave/import-availed",
  },
};
